<template>
    <header class="fixed-top">
        <nav class="bg-white shadow flex items-center justify-between px-5">
            <div class="flex items-center justify-between flex-1 sm:flex-none" style="width: 238px;">
                <router-link :to="{name: 'dashboard'}" class="logo">
                    <img src="@/assets/logo-180x180.png" alt="logo" style="height: 30px;" />
                </router-link>
                <!-- Sidebar toggle button-->
                <a 
                    class="cursor-pointer p-3" 
                    @click="toggle_menu"
                >
                    <menu-icon />
                </a>
            </div>
            <div class="items-center flex-none hidden sm:flex">
                <a @click="fullscreen" class="cursor-pointer p-3 hidden">
                    <fullscreen-icon />
                </a>
                <dropdown class="hidden">
                    <template slot="trigger">
                        <div class="relative p-3">
                            <notifications-none-icon />
                            <span 
                                class="bg-red-500 text-xs text-white absolute rounded-full"
                                style="padding: 1px 7px;top: 7px;right: 1px;"
                            >4</span>
                        </div>
                    </template>
                </dropdown>

                <!--rightside toggle-->
                <div class="relative cursor-pointer p-3 hidden" @click="toggle_right">
                    <forum-icon />
                    <span 
                        class="bg-green-500 text-xs text-white absolute rounded-full"
                        style="padding: 1px 7px;top: 7px;right: 0px;"
                    >2</span>
                </div>
                <!--rightside toggle-->

                <dropdown class="flex-none">
                    <template slot="trigger">
                        <div class="flex items-center pl-3 py-2">
                            <img 
                                :src="user.images.profile" 
                                class="rounded-circle" 
                                alt="User Image"
                                width="35"
                                height="35" 
                            >
                            <span class="text-sm ml-2 hidden sm:block">{{user.name}}</span>
                        </div>
                    </template>
                    <template slot="items">                        
                        <router-link 
                            to="/settings" 
                            exact 
                            class="dropdown-item"
                        >
                            <settings-icon width="20" height="20" />
                            <span class="ml-2">Settings</span>
                        </router-link>
                        <div @click="logout" class="dropdown-item">
                            <exit-to-app-icon width="20" height="20" />
                            <span class="ml-2">Logout</span>
                        </div>
                    </template>
                </dropdown>
            </div>
        </nav>
    </header>
</template>
<script>
    import screenfull from "screenfull"
    import {
        mapGetters
    } from 'vuex'

    export default {
        name: 'vueadmin_header',
        components: {
            MenuIcon: () => import(/* webpackChunkName: "menu-icon" */ '@/icons/Menu.vue'),
            FullscreenIcon: () => import(/* webpackChunkName: "fullscreen-icon" */ '@/icons/Fullscreen.vue'),
            NotificationsNoneIcon: () => import(/* webpackChunkName: "notifications-none-icon" */ '@/icons/NotificationsNone.vue'),
            ForumIcon: () => import(/* webpackChunkName: "forum-icon" */ '@/icons/Forum.vue')
        },
        computed: {
            ...mapGetters({
                user: 'auth/user'
            })
        },
        data() {
            return {
                
            }
        },
        methods: {
            toggle_menu() {
                this.$store.commit('left_menu', "toggle");
            },
            fullscreen() {
                if (screenfull.enabled) {
                    screenfull.toggle();
                }
            },
            toggle_right() {
                this.$store.commit('rightside_bar', "toggle");

            },
            logout() {
                this.$store.commit('setLoading', true);
                this.$store.dispatch('auth/logout')
                    .then(() => {
                        this.$router.push({ name: 'login' })
                        this.$store.commit('setLoading', false)
                    })
                    .catch(() => {
                        this.$store.commit('setLoading', false)
                    })
            }
        },
    }
</script>